import { SET_MAIN_STATE } from '../constants/redux_types'

export const setMainState = payload => {
  return {
    type: SET_MAIN_STATE,
    payload: payload
  }
}
